import { render } from "./DirectMailAudience.vue?vue&type=template&id=bac4a2bc&scoped=true"
import script from "./DirectMailAudience.vue?vue&type=script&lang=js"
export * from "./DirectMailAudience.vue?vue&type=script&lang=js"

import "./DirectMailAudience.vue?vue&type=style&index=0&id=bac4a2bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bac4a2bc"]])

export default __exports__